import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import keycloak from '../keycloak-init';

@Injectable({
  providedIn: 'root'
})
export class RoleRedirectGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!keycloak.authenticated) {
      keycloak.login();
      return false;
    }

    const roles = keycloak.tokenParsed?.resource_access?.['sc-ms-mb-gateway']?.roles ?? [];

    const isAdmin = roles.some((role) => role === 'admin');

    if (state.url === '/' || state.url === '') {
      this.router.navigate([isAdmin ? '/administrativo' : '/customer-dashboard']);
      return false;
    }

    if (!isAdmin && state.url.startsWith('/administrativo')) {
      this.router.navigate(['/customer-dashboard']);
      return false;
    }

    if (isAdmin && state.url.startsWith('/customer-dashboard')) {
      this.router.navigate(['/administrativo']);
      return false;
    }

    return true;
  }
}
